export const USERCARD_PICK_MAXWIDTH = 74;
export const USERCARD_PICK_HEIGHT = 100;
